<template>
  <v-snackbar
      v-model="show"
      :timeout="4000"
    >
      {{ message }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="pink"
          text
          v-bind="attrs"
          @click="show = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
</template>

<script>
export default {
  data: () => ({
    show : false,
    message: "",
  }),
  mounted() {
    this.$root.$on("Notification", (msg) => {
      this.show = true;
      this.message = msg;
    });
  }
};
</script>